import { useMantineTheme } from "@mantine/core";

/**
 * Custom hook to access the current Mantine theme.
 * @returns The current Mantine theme object.
 */
export const useTheme = () => {
    return useMantineTheme();
};
